<div class="toast-stack" aria-live="polite">
  @for (t of toasts(); track t.n.id) {
    <div class="toast"
         [class.leaving]="t.leaving"
         [class.clickable]="!!t.n.link"
         role="status"
         (mouseenter)="pause(t)"
         (mouseleave)="resume(t)"
         (click)="open(t)">
      <div class="toast-icon" [style.background]="metaFor(t.n.type).color + '1f'">
        <mat-icon [style.color]="metaFor(t.n.type).color">{{ metaFor(t.n.type).icon }}</mat-icon>
      </div>
      <div class="toast-body">
        <p class="toast-message">{{ svc.messageFor(t.n) }}</p>
        @if (t.n.link) {
          <span class="toast-hint">{{ 'notifications.toast.open-hint' | translate }}</span>
        }
      </div>
      <button mat-icon-button
              class="toast-close"
              [attr.aria-label]="'notifications.toast.close' | translate"
              (click)="dismiss(t, $event)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
